<script>
import api from "@/api";

const PROMPT_MAP = {
  quiz: "Тесты",
  chunkCreate: "Чанки",
  question_answer: "Вопросы-ответы",
  heading: "Заголовок",
  rephrase: "Парафраз",
  distractors: "Дистракторы",
  quizBasedQA: "Тесты из вопрос-ответов",
  table2text: "Таблицу в текст"
};

export default {
  name: "AiHistory",
  data() {
    const now = new Date();
    return {
      mode: "history",

      filter: {
        search: null,
        dateFrom: new Date(new Date().setDate(now.getDate() - 7)).toISOString().split("T")[0],
        dateTo: now.toISOString().split("T")[0]
      },
      tableData: {
        headers: [
          {
            key: "fullname",
            label: "Пользователь",
            sortable: true
          },
          {
            key: "model_code",
            label: "Модель",
            sortable: true
          },
          {
            key: "requests",
            label: "Запросов",
            sortable: true
          },
          {
            key: "token_in",
            label: "Токенов отправлено",
            sortable: true
          },
          {
            key: "token_out",
            label: "Токенов получено",
            sortable: true
          }
        ],
        items: [],
        loading: true,
        options: {
          sortBy: "fullname",
          sortDesc: false
        }
      }
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.loadData();
      }
    }
  },
  methods: {
    async loadData() {
      this.tableData.loading = true;
      return api.get(`/generator/history-grouped`, { params: this.filter }).then((response) => {
        if (response.status === 200) {
          this.tableData.items = response.data;
        }
      }).finally(() => this.tableData.loading = false);
    }
  }
};
</script>

<template>
  <b-card title="История запросов">

    <b-card-text>
      <b-row>
        <b-button-toolbar class="button_toolbar">
          <b-button-group class="mx-1">
            <b-btn
              :disabled="tableData.loading"
              variant="outline-primary"
              @click="loadData"
            >
              <font-awesome-icon v-if="!tableData.loading" fixed-width icon="rotate-right" />
              <b-spinner v-else small type="border"></b-spinner>
              Обновить
            </b-btn>
          </b-button-group>
        </b-button-toolbar>
      </b-row>

      <b-input-group class="float-right mr-2 " style="width: 650px">
        <label for="date1" class="mr-2">Дата С</label>
        <b-datepicker id="date1" v-model="filter.dateFrom" placeholder="Дата С" />
        <label for="date2" class="mr-2">Дата ПО</label>
        <b-datepicker id="date2" v-model="filter.dateTo" placeholder="Дата ПО" />
      </b-input-group>

      <b-table
        hover
        small
        responsive
        :items="tableData.items"
        :fields="tableData.headers"
        :per-page="-1"
        :sort-by.sync="tableData.options.sortBy"
        :sort-desc.sync="tableData.options.sortDesc"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Данные загружаются...</strong>
          </div>
        </template>
      </b-table>

    </b-card-text>


  </b-card>
</template>

<style scoped>

</style>